// Socket.io event payload types

export interface FollowUpQuestionsGeneratedEvent {
  event_type: string;
  vendor_email: string;
  timestamp: string;
  data: Record<string, unknown>;
  chat_id: string;
  questions: { id: string; question: string }[];
  role: string;
  metadata: Record<string, unknown>;
}

export interface AiMessageEvent {
  chat_id: string;
  organization_id?: string;
  agent_session_id?: string;
  event:
    | "ai_message_start"
    | "ai_message_delta"
    | "ai_message_end"
    | "ai_message_reasoning";
  message_id?: string;
  message?: string;
  reasoning?: {
    follow_up_question_id: string;
    follow_up_question_index: number;
    reason_for_vendor: {
      title: string;
      description: string;
    };
  }[];
}

export interface FollowUpAnsweredStatusEvent {
  chat_id: string;
  organization_id: string;
  agent_session_id: string;
  event: string;
  message_id: string;
  answered_count: number;
  answered_percent: number;
  unanswered_count: number;
  total_questions: number;
  are_all_questions_answered: boolean;
}

export interface AssessmentRoomsReadyEvent {
  event_type: string;
  agent_session_id: string;
  timestamp: string;
}

export const SOCKET_EVENTS = {
  ASSESSMENT_ROOMS_READY: "tpra:assessment:rooms:ready",
  FOLLOW_UP_GENERATED: "tpra:follow_up:questions:generated",
  AI_MESSAGE: "tpra:followup:chat:ai:message",
  ANSWERED_STATUS: "tpra:followup:answered:status",
} as const;
